import statusService from '../../Actions/statusService';
const { types } = statusService;

const initialState = {
};

const statusServiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_STATUS_SAT_DESCARGA_MASIVA:
			return {
				...state,
            };
        default:
            return state;
    }
}


export default statusServiceReducer;